import { usePageContext } from "../../../hooks/context";
import { usePackage } from "../../../hooks/package";
import type { OnboardingPackage } from "../../../types/package";
import { isCreditWorthy } from "../helpers";
import { useChoosePackage } from "../hooks";
import { usePreSelectedPackage } from "./usePreSelectedPackage";

export const usePromotedPackage = (): OnboardingPackage | undefined => {
	const { selectedPackage } = usePackage();
	const { availablePackages, creditScore } = usePageContext(useChoosePackage);
	const preSelectedPackage = usePreSelectedPackage();

	const foretagarnaBasePackage = availablePackages.find((p) => p?.packageId === "FÖRETAGARNA-BAS");
	const growPackage = availablePackages.find((p) => p?.packageId === "BAAS-FÖRETAG-VÄXA");
	const basePackage = availablePackages.find((p) => p?.packageId === "BAAS-FÖRETAG-BAS");
	const ehandelPackage = availablePackages.find((p) => p?.packageId === "E-HANDEL-BAS");

	const isCreditAvailable = creditScore?.assessment && isCreditWorthy(creditScore.assessment);
	const isEhandelPackageSelected = selectedPackage?.packageId === "E-HANDEL-BAS";

	if (isEhandelPackageSelected && ehandelPackage) {
		return ehandelPackage;
	}

	if (preSelectedPackage) {
		return preSelectedPackage;
	}

	if (foretagarnaBasePackage) {
		return foretagarnaBasePackage;
	}

	if (isCreditAvailable && growPackage) {
		return growPackage;
	}

	return basePackage;
};
